import { mapToObject } from "./mapToObject";
import { objectToMap } from "./objectToMap";

export const appendTabWithSelection = (idTab: string, idRow: string) => {
    const openedTabsWithSelectionsMap: Map<string, string> = objectToMap(JSON.parse(localStorage.getItem('openedTabsWithSelections') || '{}'));
    openedTabsWithSelectionsMap.set(idTab, idRow);

    try {
        localStorage.setItem('openedTabsWithSelections', JSON.stringify(mapToObject(openedTabsWithSelectionsMap)));
    }
    catch (err) {
        console.error(err)
    }
}
